import styled from 'styled-components'

import { Box } from '../components/box'
import { Subtitle } from '../components/title'
import { Text } from '../components/text'
import { Image } from '../components/image'

const StyledExperienceHeader = styled(Box)`
    align-items: flex-start;
    gap: 0;
    flex-direction: column;

    @media only screen and (min-width: 768px) {
        flex-direction: row;
        justify-content: space-between;
    }

    @media print {
        flex-direction: row;
        justify-content: space-between;
        align-items: baseline;
        gap: 0.5rem;
    }
`

const StyledExperienceDescription = styled(Box)`
    gap: 1em;
    h2, p {
        margin: 0;
    }
    align-items: flex-start;

    @media print {
        gap: 0.35rem;
    }
`

const StyledExperienceItem = styled(Box)`
    align-items: flex-start;

    @media print {
        gap: 0.75rem;
        break-inside: avoid-page;
        page-break-inside: avoid;
        margin-bottom: 0.85rem;

        img {
            width: 4.5rem;
        }
    }
`

const ExperienceItem = ({ company, role, description, period, logo }) => {
    return <StyledExperienceItem row>
        <Image src={ logo } width="100px"/>
        <StyledExperienceDescription>
                <StyledExperienceHeader>
                    <div>
                        <Subtitle bold>{ role }</Subtitle>
                        <Text>{ company }</Text>
                    </div>
                    <Text color="main">{ period }</Text>
                </StyledExperienceHeader>
                <Text>{ description }</Text>
        </StyledExperienceDescription>
        </StyledExperienceItem>
}

export const Experiences = ({ experiences}) => experiences.map(item => <ExperienceItem
    key={ item.company }
    period={ item.period }
    company={ item.company }
    role={ item.role }
    logo={ item.logo }
    description={ item.description }
/>)
